SupportGetawaysTonightStatusAndNotesPresentation =
	confirmed:
		status: "Booked"
		notes:  "Your reservation is scheduled for tonight. If you need immediate assistance, contact us at 888-963-3633 from 8 a.m. - 6 p.m. CT."
	used:
		status: "Reservation has passed"
	failed:
		status: "Problem charging your credit card"

module.exports = SupportGetawaysTonightStatusAndNotesPresentation
